<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TDYyhy/tc-custom/9781614174530.jpg?1678668704467" alt="This image is the cover for the book With This Ring (A Lexie Starr Mystery, Book 4), A Lexie Starr Mystery"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">With This Ring (A Lexie Starr Mystery, Book 4), A Lexie Starr Mystery
      </h1>
      <p class="bookDescription body article font2">
        <b>Preacher Dead--Wedding Still On, in <i>With This Ring</i>, a Cozy Mystery by Jeanne Glidewell</b><br/><br/>Lexie Starr, a 50-year-old widowed library assistant, fell in love with Stone Van Patten while helping him run his B&amp;B.<br/>Now, ten days before the wedding, all heck breaks loose when the pastor is found murdered. Not wanting to postpone the wedding, or look insensitive, Lexie launches her own investigation, breaks her wrist and gets herself and her best friend in a life-or-death situation or two.<br/>But can she solve the case and make it down the aisle to wed the man who stole her heart?<br/><br/><b>Reviews:</b> <br/>"Fast and funny . . . you won’t be able to put down this humorous whodunit." <i>~Alice Duncan, author of The Daisy Gumm Majesty Mystery Series</i><br/>"I've grown to love the characters in this series and feel like I want to stay at the Alexandria B n B." <i>~Amazon Verified Reviewer</i><br/><br/><b>THE LEXIE STARR MYSTERIES,</b> in series order<br/><i>Leave No Stone Unturned<br/>The Extinguished Guest<br/>Haunted<br/>With This Ring<br/>Just Ducky<br/>The Spirit of the Season (A Holiday Novella)<br/>Cozy Camping<br/>Marriage and Mayhem</i><br/><br/><b>THE RIPPLE EFFECT MYSTERIES, </b>in series order<br/><i>A Rip Roaring Good Time<br/>Rip Tide<br/>Ripped to Shreds<br/>Rip Your Heart Out<br/>Ripped Apart<br/>Ripped Off<br/>No Big Rip<br/>The Grim Ripper</i><br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeanne Glidewell
      </h2>
      
      <p class="authorDescription body article">A pancreas/kidney transplant recipient, Jeanne lives in Texas, with her husband and chubby cat. When Jeanne isn&#39;t writing, she&#39;s promoting organ donation and stalking wildlife with her camera.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      ePublishing Works!
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?13de59aa